import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';
import styled from '@emotion/styled';

import iconSet from '../images/teambuildr-selection.json';
import Modal from '../_TBComponents/Modal';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  font-family: 'Nunito Sans', sans-serif;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ModalTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: #444444;
  margin: 0;
  letter-spacing: -0.24px;
  line-height: normal;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9e9e9e;
  flex-shrink: 0;

  &:hover {
    opacity: 0.7;
  }
`;

const ModalDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #9e9e9e;
  margin: 0;
  line-height: 1.5;
`;

const ModalOrganizationLocked = ({ isOpen, onRequestClose }) => {
  const location = useLocation();
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const isAdmin = !!currentUser?.admin || location.pathname === '/weightroom-view';

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      customButton
      hideTitle
      customBorderRadius='12px'
      customMinHeight='auto'
      customMaxWidth='400px'
      customPadding='24px'
    >
      <ModalContent>
        <TitleRow>
          <ModalTitle>Organization Locked</ModalTitle>
          <CloseButton onClick={onRequestClose} type='button' aria-label='Close'>
            <IcomoonReact iconSet={iconSet} size={16} icon='remove' color='#9e9e9e' />
          </CloseButton>
        </TitleRow>
        <ModalDescription>
          {isAdmin
            ? 'This organization has expired, please reach out to TeamBuildr Support to reinstate.'
            : 'This organization is locked. Please reach out to the account admin for more information. If you have account switching, you can switch to another organization here.'}
        </ModalDescription>
      </ModalContent>
    </Modal>
  );
};

ModalOrganizationLocked.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default ModalOrganizationLocked;
